export default __webpack_public_path__ + "static/media/img7.0f86a46c.png";